import { render, staticRenderFns } from "./RelatedForumsContainer.vue?vue&type=template&id=4ff38c3e&scoped=true&"
import script from "./RelatedForumsContainer.vue?vue&type=script&lang=js&"
export * from "./RelatedForumsContainer.vue?vue&type=script&lang=js&"
import style0 from "./RelatedForumsContainer.vue?vue&type=style&index=0&id=4ff38c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff38c3e",
  null
  
)

export default component.exports